import React from 'react'

import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './CurrentPlanButton.scss'


const CurrentPlanButton = () => (
  <Text
    className={s.currentPlan}
    message={messages.currentPlan}
    align="center"
    uppercase
    bold
  />
)


export default CurrentPlanButton
